/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { aggregatorsCheckIsMobileValid } from '../fn/aggregators/aggregators-check-is-mobile-valid';
import { AggregatorsCheckIsMobileValid$Params } from '../fn/aggregators/aggregators-check-is-mobile-valid';
import { aggregatorsCreateAggregatorGet } from '../fn/aggregators/aggregators-create-aggregator-get';
import { AggregatorsCreateAggregatorGet$Params } from '../fn/aggregators/aggregators-create-aggregator-get';
import { aggregatorsCreateAggregatorPost } from '../fn/aggregators/aggregators-create-aggregator-post';
import { AggregatorsCreateAggregatorPost$Params } from '../fn/aggregators/aggregators-create-aggregator-post';
import { aggregatorsGetAggregatorsAudit } from '../fn/aggregators/aggregators-get-aggregators-audit';
import { AggregatorsGetAggregatorsAudit$Params } from '../fn/aggregators/aggregators-get-aggregators-audit';
import { aggregatorsGetAllAggregators } from '../fn/aggregators/aggregators-get-all-aggregators';
import { AggregatorsGetAllAggregators$Params } from '../fn/aggregators/aggregators-get-all-aggregators';
import { aggregatorsGetNumberAggregator } from '../fn/aggregators/aggregators-get-number-aggregator';
import { AggregatorsGetNumberAggregator$Params } from '../fn/aggregators/aggregators-get-number-aggregator';
import { aggregatorsGetNumbersAggregator } from '../fn/aggregators/aggregators-get-numbers-aggregator';
import { AggregatorsGetNumbersAggregator$Params } from '../fn/aggregators/aggregators-get-numbers-aggregator';
import { aggregatorsUpdateRegexGet } from '../fn/aggregators/aggregators-update-regex-get';
import { AggregatorsUpdateRegexGet$Params } from '../fn/aggregators/aggregators-update-regex-get';
import { aggregatorsUpdateRegexPost } from '../fn/aggregators/aggregators-update-regex-post';
import { AggregatorsUpdateRegexPost$Params } from '../fn/aggregators/aggregators-update-regex-post';
import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfBoolean } from '../models/custom-result-of-boolean';
import { CustomResultOfGetAggregatorByIdDto } from '../models/custom-result-of-get-aggregator-by-id-dto';
import { CustomResultOfListOfGetAllAggregatorsDto } from '../models/custom-result-of-list-of-get-all-aggregators-dto';
import { CustomResultOfListOfGetNumbersAggregatorDto } from '../models/custom-result-of-list-of-get-numbers-aggregator-dto';
import { CustomResultOfSmsAggregator } from '../models/custom-result-of-sms-aggregator';

@Injectable({ providedIn: 'root' })
export class AggregatorsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `aggregatorsGetAllAggregators()` */
  static readonly AggregatorsGetAllAggregatorsPath = '/Aggregators/GetAllAggregators';

  /**
   * Get All Aggregators.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aggregatorsGetAllAggregators()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorsGetAllAggregators$Response(params?: AggregatorsGetAllAggregators$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetAllAggregatorsDto>> {
    return aggregatorsGetAllAggregators(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Aggregators.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aggregatorsGetAllAggregators$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorsGetAllAggregators(params?: AggregatorsGetAllAggregators$Params, context?: HttpContext): Observable<CustomResultOfListOfGetAllAggregatorsDto> {
    return this.aggregatorsGetAllAggregators$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetAllAggregatorsDto>): CustomResultOfListOfGetAllAggregatorsDto => r.body)
    );
  }

  /** Path part for operation `aggregatorsCheckIsMobileValid()` */
  static readonly AggregatorsCheckIsMobileValidPath = '/Aggregators/CheckIsMobileValid';

  /**
   * Check Is Mobile Valid.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aggregatorsCheckIsMobileValid()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorsCheckIsMobileValid$Response(params?: AggregatorsCheckIsMobileValid$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfBoolean>> {
    return aggregatorsCheckIsMobileValid(this.http, this.rootUrl, params, context);
  }

  /**
   * Check Is Mobile Valid.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aggregatorsCheckIsMobileValid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorsCheckIsMobileValid(params?: AggregatorsCheckIsMobileValid$Params, context?: HttpContext): Observable<CustomResultOfBoolean> {
    return this.aggregatorsCheckIsMobileValid$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfBoolean>): CustomResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `aggregatorsGetNumberAggregator()` */
  static readonly AggregatorsGetNumberAggregatorPath = '/Aggregators/GetNumberAggregator';

  /**
   * Get Number Aggregator.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aggregatorsGetNumberAggregator()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorsGetNumberAggregator$Response(params?: AggregatorsGetNumberAggregator$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfSmsAggregator>> {
    return aggregatorsGetNumberAggregator(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Number Aggregator.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aggregatorsGetNumberAggregator$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorsGetNumberAggregator(params?: AggregatorsGetNumberAggregator$Params, context?: HttpContext): Observable<CustomResultOfSmsAggregator> {
    return this.aggregatorsGetNumberAggregator$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfSmsAggregator>): CustomResultOfSmsAggregator => r.body)
    );
  }

  /** Path part for operation `aggregatorsCreateAggregatorGet()` */
  static readonly AggregatorsCreateAggregatorGetPath = '/Aggregators/CreateAggregator';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aggregatorsCreateAggregatorGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorsCreateAggregatorGet$Response(params?: AggregatorsCreateAggregatorGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return aggregatorsCreateAggregatorGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aggregatorsCreateAggregatorGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorsCreateAggregatorGet(params?: AggregatorsCreateAggregatorGet$Params, context?: HttpContext): Observable<Blob> {
    return this.aggregatorsCreateAggregatorGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `aggregatorsCreateAggregatorPost()` */
  static readonly AggregatorsCreateAggregatorPostPath = '/Aggregators/CreateAggregator';

  /**
   * Create Aggregator.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aggregatorsCreateAggregatorPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  aggregatorsCreateAggregatorPost$Response(params: AggregatorsCreateAggregatorPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return aggregatorsCreateAggregatorPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Aggregator.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aggregatorsCreateAggregatorPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  aggregatorsCreateAggregatorPost(params: AggregatorsCreateAggregatorPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.aggregatorsCreateAggregatorPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `aggregatorsUpdateRegexGet()` */
  static readonly AggregatorsUpdateRegexGetPath = '/Aggregators/UpdateRegex';

  /**
   * Get Aggregator By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aggregatorsUpdateRegexGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorsUpdateRegexGet$Response(params?: AggregatorsUpdateRegexGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetAggregatorByIdDto>> {
    return aggregatorsUpdateRegexGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Aggregator By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aggregatorsUpdateRegexGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  aggregatorsUpdateRegexGet(params?: AggregatorsUpdateRegexGet$Params, context?: HttpContext): Observable<CustomResultOfGetAggregatorByIdDto> {
    return this.aggregatorsUpdateRegexGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetAggregatorByIdDto>): CustomResultOfGetAggregatorByIdDto => r.body)
    );
  }

  /** Path part for operation `aggregatorsUpdateRegexPost()` */
  static readonly AggregatorsUpdateRegexPostPath = '/Aggregators/UpdateRegex';

  /**
   * به روز رسانی regex.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aggregatorsUpdateRegexPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  aggregatorsUpdateRegexPost$Response(params: AggregatorsUpdateRegexPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return aggregatorsUpdateRegexPost(this.http, this.rootUrl, params, context);
  }

  /**
   * به روز رسانی regex.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aggregatorsUpdateRegexPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  aggregatorsUpdateRegexPost(params: AggregatorsUpdateRegexPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.aggregatorsUpdateRegexPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `aggregatorsGetAggregatorsAudit()` */
  static readonly AggregatorsGetAggregatorsAuditPath = '/Aggregators/GetAggregatorsAudit';

  /**
   * Only for super admin, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aggregatorsGetAggregatorsAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  aggregatorsGetAggregatorsAudit$Response(params: AggregatorsGetAggregatorsAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return aggregatorsGetAggregatorsAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aggregatorsGetAggregatorsAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  aggregatorsGetAggregatorsAudit(params: AggregatorsGetAggregatorsAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.aggregatorsGetAggregatorsAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `aggregatorsGetNumbersAggregator()` */
  static readonly AggregatorsGetNumbersAggregatorPath = '/Aggregators/GetNumbersAggregator';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `aggregatorsGetNumbersAggregator()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  aggregatorsGetNumbersAggregator$Response(params: AggregatorsGetNumbersAggregator$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetNumbersAggregatorDto>> {
    return aggregatorsGetNumbersAggregator(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `aggregatorsGetNumbersAggregator$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  aggregatorsGetNumbersAggregator(params: AggregatorsGetNumbersAggregator$Params, context?: HttpContext): Observable<CustomResultOfListOfGetNumbersAggregatorDto> {
    return this.aggregatorsGetNumbersAggregator$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetNumbersAggregatorDto>): CustomResultOfListOfGetNumbersAggregatorDto => r.body)
    );
  }

}
